import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Token, TokenState } from './tokens.types';
import { State } from '../state.types';
import TokensService from '../../services/TokensService/TokensService';

export const fetchTokens = createAsyncThunk(
  'tokens/fetch',
  TokensService.getTokens,
);

const initialState: TokenState = {
  name: '',
  iconSmall: { mobileUrl: '', desktopUrl: '' },
  iconLarge: { mobileUrl: '', desktopUrl: '' },
  balance: 0,
};

const tokens = createSlice({
  name: 'tokens',
  initialState,
  reducers: {
    setToken(state, { payload }: PayloadAction<Partial<Token>>) {
      Object.assign(state, payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTokens.fulfilled, (state, { payload }) => {
      state.balance = payload.amount;
    });
  },
});

export const { setToken } = tokens.actions;

export const selectTokenName = (state: State) => state.tokens.name;

export const selectTokenIconSmall = (state: State) => state.tokens.iconSmall;

export const selectTokenIconLarge = (state: State) => state.tokens.iconLarge;

export const selectTokenBalance = (state: State) => state.tokens.balance;

export default tokens.reducer;
